// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myAccountViewStyles } from "@conklin/Overrides/Widgets/MyAccount/MyAccountView";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

myAccountViewStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(0, 317px) minmax(0, 1fr);
        grid-column-gap: 22px;
        width: 100%;
        background: ${color("common.white")};
        ${xScreen("lte", "md")} {
            grid-column-gap: 0;
        }
    `,
};

myAccountViewStyles.navigationList = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 7;
        display: flex;
        flex-direction: column;
        gap: 32px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 2 / 3;
        }
    `,
};

myAccountViewStyles.pageTitle = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
    `,
};

myAccountViewStyles.welcomeSection = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 3;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 3 / 4;
        }
    `,
};

myAccountViewStyles.messageWrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
        padding-bottom: 20px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 20px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            row-gap: 8px;
        }
    `,
};

myAccountViewStyles.accountMessages = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 3 / 4;
        &:not(:empty) {
            padding-bottom: 20px;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 4 / 5;
        }
    `,
};

myAccountViewStyles.quickOrderSection = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 4 / 5;
        padding-bottom: 20px;
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
        }
    `,
};

myAccountViewStyles.dashboardWidgets = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 5/ 6;
        > div {
            display: flex;
            flex-direction: column;
            gap: 24px;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 6 / 7;
        }
    `,
};

myAccountViewStyles.extraCardsDesktop = {
    below: "lg",
    css: css`
        > div {
            display: flex;
            flex-direction: column;
            gap: 32px;
        }
        &:empty {
            display: none;
        }
    `,
};

myAccountViewStyles.extraCardsMobile = {
    css: css`
        grid-column: 1 / 3;
        grid-row: 7/ 8;
        > div {
            display: flex;
            flex-direction: row;
            gap: 20px;
            padding-top: 48px;
            > div {
                height: fit-content;
                width: 50%;
            }
            ${xScreen("lte", "sm")} {
                flex-direction: column;
                gap: 32px;
                > div {
                    width: 100%;
                }
            }

            &:empty {
                display: none;
            }
        }
    `,
};
